import PropTypes from 'prop-types';

function SuggestedUser({ user }) {
  const initials = user.username
    ? user.username.slice(0, 2).toUpperCase()
    : '??';

  return (
    <div className="flex items-center justify-between py-2">
      <div className="flex items-center gap-3">
        {/* Avatar */}
        <div className="w-8 h-8 rounded-full bg-gray-200 overflow-hidden flex items-center justify-center flex-shrink-0">
          {user.avatarUrl ? (
            <img
              src={user.avatarUrl}
              alt={user.username}
              className="w-full h-full object-cover"
            />
          ) : (
            <span className="text-xs font-semibold text-gray-500">
              {initials}
            </span>
          )}
        </div>

        {/* User info */}
        <div className="min-w-0">
          <p className="font-semibold text-sm text-puzzle-text truncate">
            {user.username}
          </p>
          <p className="text-xs text-puzzle-text-secondary truncate">
            {user.relation}
          </p>
        </div>
      </div>

      {/* Follow button */}
      <button
        type="button"
        className="text-puzzle-blue text-xs font-semibold hover:opacity-70 transition-opacity flex-shrink-0 ml-2"
      >
        Follow
      </button>
    </div>
  );
}

SuggestedUser.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.string.isRequired,
    username: PropTypes.string.isRequired,
    avatarUrl: PropTypes.string,
    relation: PropTypes.string,
  }).isRequired,
};

export default SuggestedUser;
